export { AuthService } from "./auth.service";
export { NotificationService } from "./notification.service";

export { ServicioService } from "./configuracion/servicio.service";
export { UsuarioService } from "./configuracion/usuario.service";
export { EstudianteService } from "./configuracion/estudiante.service";
export { PerfilEstudianteService } from "./configuracion/perfil-estudiante.service";
export { CertificadoNotasService } from "./configuracion/certificado-notas.service";
export { CajaService } from "./operacion/caja.service";
export { VentaService } from "./operacion/venta.service";
export { DashboardService } from "./reportes/dashboard.service";
export { DtesPDF } from "./reportes/dtespdf.service";
export { PersistenceService} from "./persistence.service";
export { GeneralService } from "./general.service";
export { NavegationService } from "./navegation.service";
export { PDFService } from "./utilidades/pdf.service";
export { ExcelService } from "./exel.service";
export {ExcelPopulateService} from "./excelPopulate.service";
export { PagoPDFService } from "./utilidades/pagoPdf.service";
export { ReciboPDFService } from "./utilidades/reciboPdf.service";

